/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { PermissionDescriptorFromJSON, PermissionDescriptorToJSON, ResourceTagFromJSON, ResourceTagToJSON, } from './';
export function RoleRequestFromJSON(json) {
    return RoleRequestFromJSONTyped(json, false);
}
export function RoleRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'tags': !exists(json, 'tags') ? undefined : (json['tags'].map(ResourceTagFromJSON)),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'permissions': !exists(json, 'permissions') ? undefined : (json['permissions'].map(PermissionDescriptorFromJSON))
    };
}
export function RoleRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'tags': value.tags === undefined ? undefined : (value.tags.map(ResourceTagToJSON)),
        'description': value.description,
        'permissions': value.permissions === undefined ? undefined : (value.permissions.map(PermissionDescriptorToJSON))
    };
}
